"use client";

import type { Pricelist, PricelistItem } from "@raumagarn/formatters";
import { useSelection } from "@trydig/centra/client";

const emptyPrice = {
	discountPercent: 0,
	lowestPrice: [],
	price: "",
	priceAsNumber: 0,
	priceBeforeDiscount: "",
	priceBeforeDiscountAsNumber: 0,
	showAsNew: false,
	showAsOnSale: false,
};

export const getPrice = ({
	pricelist,
	pricelistId,
}: {
	pricelist?: Pricelist;
	pricelistId?: number;
}): PricelistItem => {
	if (!pricelist) return emptyPrice;

	const pricelistKey = pricelistId?.toString();
	const priceData = pricelist[pricelistKey || ""];

	return priceData ? priceData : emptyPrice;
};

export const usePrice = ({ pricelist }: { pricelist?: Pricelist }) => {
	const pricelistId = usePricelistId();

	const price = getPrice({ pricelist, pricelistId });

	return price;
};

export const usePricelistId = () => {
	const { data: pricelistId } = useSelection({
		select: (data) => data.location?.pricelist,
	});

	return pricelistId;
};

export type UsePriceReturn = ReturnType<typeof usePrice>;
